import { useDarkMode } from "@/hooks";
import { Event } from "@/models/Cart";
import { dateToPortalDisplay } from "@/utils/date";
import { parseISO } from "date-fns";
import { SquareArrowOutUpRight } from "lucide-react";

interface Props {
  event: Event;
  children?: React.ReactNode;
}

export const EventCard = ({ event, children }: Props) => {
  const darkMode = useDarkMode();
  return (
    <>
      <div className="dark:bg-dark-secondary bg-white border dark:border-white/5 shadow-sm rounded-lg shadow-lg p-6 max-w-md w-full">
        <div className="text-center mb-6">
          <img
            src={event.logo}
            alt={`${event.name} logo`}
            className="w-24 h-24 mx-auto rounded-full mb-4"
          />
          <h1 className="text-xl font-semibold">{event.name}</h1>
          <p className="text-muted-foreground text-orange-500 text-sm">
            {dateToPortalDisplay(parseISO(event.startDate))}
          </p>
          <p className="text-xs text-gray-400">{event.location}</p>
        </div>

        {children}
      </div>

      <div className="max-w-md pl-3 pt-4">
        <div className="flex">
          <div className="mr-2 flex items-center justify-center">
            <svg
              id="Livello_2"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 150.55 209.09"
              className={`w-7 ${darkMode ? "fill-white" : "fill-black"}`}
            >
              <path d="m110.26,44.92V0h-49.61v47.45H0l19.53,24.22L0,95.89h60.64v48.56c0,21.42,5.62,37.73,16.7,48.49,11.05,10.72,27.99,16.16,50.35,16.16h22.85v-44.8h-22.85c-12.06,0-17.44-5.38-17.44-17.44v-50.97h40.29v-48.44h-40.29v-2.53Z" />
            </svg>
          </div>
          <div className="ml-3 flex items-center justify-center">
            <h3 className="text-sm">
              Powered by{" "}
              <span
                onClick={() => window.open("https://ticketr.events", "_blank")}
                className="cursor-pointer underline font-semibold dark:text-gray-300"
              >
                Ticketr
                <SquareArrowOutUpRight className="w-3 h-3 inline-block ml-1 -mt-0.5" />
              </span>
              . By claiming your ticket, you agree to our{" "}
              <a href="#" className="underline">
                Terms
              </a>{" "}
              and{" "}
              <a href="#" className="underline">
                Privacy Policy
              </a>
              .
            </h3>
          </div>
        </div>
      </div>
    </>
  );
};
